import { Box, Stack, useElementBreakpoints } from "@compass/core";
import { CustomFilters } from "components";
import {
  CustomFilterEntity,
  StudentEnrollmentFilterResource,
  StudentFilterResource,
  StudentServiceFilter as StudentServiceFilterModel,
  StudentServiceFilterResource,
  StudentFilter as StudentFilterModel,
  StudentEnrollmentFilter as StudentEnrollmentFilterModel,
  CustomFilter
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { CustomEntityOption } from "components/common/CustomFilters/CustomFilter";
import { StudentServiceFilterAccordion } from "./StudentServiceFilterAccordion";
import { StudentDemographicsFilterAccordion } from "../students/StudentDemographicsFilterAccordion";
import { StudentEnrollmentFilterAccordion } from "../student-enrollments/StudentEnrollmentFilterAccordion";
import { FilterAccordion } from "components/common/CustomFilters/FilterAccordion";

type InputType =
  | "customFilters"
  | "date"
  | "dateFrom"
  | "dateTo"
  | "student"
  | "serviceType"
  | "serviceSubType"
  | "serviceRecipient"
  | "provider"
  | "flagForReview"
  | "duration";
// | "isLocked"
// | "serviceName"
// | "parentCount";

export const StudentServiceFilter = (props: {
  customFilters: CustomFilter[];
  studentServicefilter: StudentServiceFilterModel;
  studentDemographicsFilter: StudentFilterModel;
  studentEnrollmentFilter?: StudentEnrollmentFilterModel;
  setStudentServiceFilter: (filter: StudentServiceFilterModel) => void;
  setStudentDemographicFilter: (filter: StudentFilterModel) => void;
  setCustomFilters: (filter: CustomFilter[]) => void;
  setStudentEnrollmentFilter?: (filter: StudentEnrollmentFilterModel) => void;
  hiddenEntities?: CustomFilterEntity[]; // If you want to hide say Enrollments or Services etc for a particular page, put them here
  showInputs?: InputType[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [demographicResource, setDemographicResource] = useState<StudentFilterResource>({} as StudentFilterResource);
  const [resource, setResource] = useState<StudentServiceFilterResource>({});
  const [enrollmentResource, setEnrollmentResource] = useState<StudentEnrollmentFilterResource>({});



  const entityOptions: CustomEntityOption[] = [
    { EntityType: CustomFilterEntity.Student, EntityName: "Demographics" },
    { EntityType: CustomFilterEntity.StudentService, EntityName: "Service" },
  ];

  useEffect(() => {
    ApiService.studentServices.getFilterResource().then((response) => {
      setResource(response);
    });

    ApiService.studentEnrollments.getFilterResource().then((response) => {
      setEnrollmentResource(response);
    });

    ApiService.students.getFilterResource().then((response) => {
      setDemographicResource(response);
    });
  }, []);

  let inputs: InputType[] = [
    "customFilters",
    "dateFrom",
    "dateTo",
    "student",
    "serviceType",
    "serviceSubType",
    "serviceRecipient",
    "provider",
    "duration",
    "flagForReview",
    // "isLocked",
    // "serviceName",
    // "parentCount",
  ];

  if (props.showInputs) inputs = props.showInputs;


  return (
    <Stack ref={breakpointsRef} spacing="lg" padding={2}>
      {inputs.includes("customFilters") && (
        <CustomFilters
          allowedEntityTypes={entityOptions}
          filters={props.customFilters}
          setFilters={(filters) =>
            props.setCustomFilters(filters!)
          }
          properties={resource.customFilterProperties}
        />
      )}

      {!props.hiddenEntities?.some(x => x == CustomFilterEntity.Student) && (
        <Box>
          <FilterAccordion title="Demographics">
            <StudentDemographicsFilterAccordion
              resource={demographicResource}
              filter={props.studentDemographicsFilter}
              setFilter={props.setStudentDemographicFilter}
            /></FilterAccordion>
        </Box>
      )}
      {props.studentEnrollmentFilter &&
        props.setStudentEnrollmentFilter &&
        !props.hiddenEntities?.some(x => x == CustomFilterEntity.StudentEnrollment) && (
          <Box>
            <FilterAccordion title="Enrollment">
              <StudentEnrollmentFilterAccordion
                filter={props.studentEnrollmentFilter}
                setFilter={props.setStudentEnrollmentFilter}
                resource={enrollmentResource}
              /></FilterAccordion>
          </Box>
        )}
      {!props.hiddenEntities?.some(x => x == CustomFilterEntity.StudentService) && (
        <Box>
          <FilterAccordion title="Services">
            <StudentServiceFilterAccordion
              resource={resource}
              filter={props.studentServicefilter}
              setFilter={props.setStudentServiceFilter}
            /></FilterAccordion>
        </Box>
      )}
    </Stack>
  );
};
